export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5050.3e73130b.jpg";